module.exports = __webpack_public_path__ + "static/img/P7.c133916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leishenx/P7.png
// module id = ddYo
// module chunks = 0